import { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { FormEnums } from "models/enums";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { DimensionFormTypes } from "models/formTypes";
import { AddNewDimensionFormProps } from "models/propTypes/dimensionPropTypes";
//#endregion
//#region components
import GenericForm from "../forms/genericForm";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const AddNewDimensionForm: ForwardRefRenderFunction<FormHandles, AddNewDimensionFormProps> = (props, ref) => {
  return (
    <GenericForm<DimensionFormTypes.AddDimension>
      formRef={ref}
      {...props}
      fields={{
        name: {
          label: TranslationKeys.Common.Name,
          type: FormEnums.FormFieldType.TEXT,
        },
        shortName: {
          label: TranslationKeys.Settings.ShortName,
          type: FormEnums.FormFieldType.TEXT,
          disabled: props.isEdit,
        },
        isActive: {
          label: TranslationKeys.Common.Active,
          type: FormEnums.FormFieldType.TOGGLE,
          classes: { formControl: cssExports.inlineLabel },
        },
      }}
    />
  );
};

export default forwardRef(AddNewDimensionForm);
